
export interface News {
   title: string;
   published: string
   link: string
   sentiment: string
   source_name: string
   source_logo: string
}

export interface SentimentParams {
   color: string
   text: string
   icon: string
}

const anomalyParamsUp: SentimentParams = { 'color': "#6DA544", 'text': 'a augmenté', 'icon': 'https://uploads-ssl.webflow.com/641b227fcd5cd9726f0781aa/667ad40fad7f4d6c641467cb_trend-up.svg' }
const anomalyParamsDown: SentimentParams = { 'color': "#F55536", 'text': 'a baissé', 'icon': 'https://uploads-ssl.webflow.com/641b227fcd5cd9726f0781aa/667ad409cc8ba948bf6788d7_trend-down.svg' }
const anomalyParamsDefault: SentimentParams = { 'color': "#161032", 'text': '', 'icon': 'https://cdn.prod.website-files.com/641b227fcd5cd9726f0781aa/667ad403075b3c10bdbf0690_trend-up.svg' }

export const SentimentParamsOptions = {
   positive: anomalyParamsUp,
   negative: anomalyParamsDown,
   neutral: anomalyParamsDefault
}
